/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
export enum SearchFields {
  ANY = 'any',
  ID = 'id',
  NAME = 'name',
  AIR_ID = 'airId',
  ESN = 'esn',
  ICCID = 'iccid',
  IMEI = 'imei',
  IMEI2 = 'imei2',
  MEID = 'meid',
  SERIAL_NUMBER = 'serialNumber',
  TYPE = 'typeId',
  CATEGORY = 'category',
  FIRMWARE_VERSION = 'firmwareVersion',
  CONFIG_VERSION = 'configVersion',
  SCRIPT_VERSION = 'scriptVersion',
  ID_REPORT_TIMESTAMP = 'idReportTimestamp',
  LAST_REPORT_DATE = 'lastReportedTime',
  STATUS = 'status',
  GROUPS = 'groupIds',
  APP_ID = 'appId',
  ARCHITECTURE = 'architecture',
  ANDROID_OS_VERSION = 'androidOSVersion',
  ASSET_NAME = 'asset.title',
  ACCOUNT_NAME = 'account.title',
  KERNEL_VERSION = 'kernelVersion',
  VBUS_STATUS = 'vbusEnabledStatus',
  VBUS_MODE = 'vbusMode',
  MDT = 'mdt',
  LMU = 'lmu',
  USER_ESN_MOBILE_ID = 'userESN',
  JPOD_FIRMWARE = 'jpodFirmware',
  JPOD_CONFIG = 'jpodConfig',
  BLE3_FIRWARE = 'ble3Firmware',
  VBU3_FIRWARE = 'vbu3Firmware',
  BSP_MODEM_FIRWARE = 'bspModemFirmware',
  CELL_RADIO_FIRWARE = 'cellRadioFirmware'
};
  
export const DEFAULT_SMART_SEARCH_QUERY = `(${SearchFields.ID}:*)`;

export const DEFAULT_SEARCH_FIELDS = [
  SearchFields.ID,
  SearchFields.NAME,
  SearchFields.AIR_ID,
  SearchFields.ESN,
  SearchFields.ICCID,
  SearchFields.IMEI,
  SearchFields.MEID,
  SearchFields.SERIAL_NUMBER,
  SearchFields.TYPE,
  SearchFields.CATEGORY,
  SearchFields.FIRMWARE_VERSION,
  SearchFields.CONFIG_VERSION,
  SearchFields.SCRIPT_VERSION,
  SearchFields.ID_REPORT_TIMESTAMP,
  SearchFields.LAST_REPORT_DATE,
  SearchFields.STATUS,
  SearchFields.GROUPS,
  SearchFields.APP_ID,
  SearchFields.ARCHITECTURE,
  SearchFields.ANDROID_OS_VERSION,
  SearchFields.ASSET_NAME,
  SearchFields.ACCOUNT_NAME,
  SearchFields.KERNEL_VERSION
];
